exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".numero[data-v-5c05eea5]{font-size:14px;padding:3px 7px;width:27px;border-radius:20px}.gris[data-v-5c05eea5]{color:#7a7a7a}.textcuenta[data-v-5c05eea5]{font-weight:700}.is-select[data-v-5c05eea5]{background-color:#3273dc;color:#fff}.is-select1[data-v-5c05eea5]{color:#00d1b2;font-size:14px}.is-error[data-v-5c05eea5]{color:#ff3860}.datospruducto table[data-v-5c05eea5],.datospruducto td[data-v-5c05eea5],.datospruducto th[data-v-5c05eea5]{font-size:14px;padding-left:3px!important;padding-right:3px!important;color:#8b8b8b!important}.datospruducto tfoot[data-v-5c05eea5]{border:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c05eea5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registrar/Viewregistrofrapvta2.vue
// module id = 702
// module chunks = 0